/**
 * useMatomo - Matomo Analytics 이벤트 추적 훅
 *
 * window._paq 타입 선언은 MatomoTracker.tsx에 이미 존재하므로 중복 선언하지 않는다.
 * Patient Portal은 환자 익명성 요구사항으로 setUserId를 사용하지 않는다.
 */

export function useMatomo() {
  const trackEvent = (
    category: string,
    action: string,
    name?: string,
    value?: number,
  ) => {
    window._paq?.push(['trackEvent', category, action, name, value]);
  };

  const setDimension = (id: number, value: string) => {
    window._paq?.push(['setCustomDimension', id, value]);
  };

  return { trackEvent, setDimension };
}
